import { render } from "./QuestionGdprScreen.vue?vue&type=template&id=5394720c&scoped=true&lang=html"
import script from "./QuestionGdprScreen.vue?vue&type=script&lang=js"
export * from "./QuestionGdprScreen.vue?vue&type=script&lang=js"

import "./QuestionGdprScreen.vue?vue&type=style&index=0&id=5394720c&lang=scss&scoped=true"

import exportComponent from "/Users/peterdevos/Apps/clawmachine_topdesk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5394720c"]])

export default __exports__